/**
 * NjitSearch behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.NjitSearch.attach}}
   */
  Drupal.behaviors.NjitSearch = {
    attach: function (context, settings) {
      var $searchModal = $('.search-modal', context);
      var $lastFocusedElement = null;

      // Function to close the modal
      var closeModal = function() {
        $searchModal.removeClass('is-open');
        $('input[name="as_q"]', $searchModal).val('');

        // Wait for animation to complete before removing body scroll lock
        setTimeout(function() {
          $('body').removeClass('search-modal-open');

          // Return focus to the search toggle button
          if ($lastFocusedElement) {
            $lastFocusedElement.focus();
            $lastFocusedElement = null;
          }
        }, 400); // Match the CSS transition duration

        $('input[name="as_q"]', $searchModal).trigger('keyup');
      };

      // Handle search toggle button clicks
      $(once('search-toggle', '.search-toggle, .search-form #edit-submit, .search-form #edit-keyword', context)).on('click', function () {
        // Store the element that opened the modal
        $lastFocusedElement = $(this);

        $searchModal.addClass('is-open');
        $('body').addClass('search-modal-open');

        // Focus the close button when modal opens
        setTimeout(function() {
          $('.search-modal-close-btn', $searchModal).focus();
        }, 100); // Small delay to ensure modal is visible

        return false;
      });

      // Handle close button clicks
      $(once('search-close', '.search-modal-close-btn', context)).on('click', function() {
        closeModal();
      });

      // ESC key to close modal
      $(document).on('keydown', function(e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && $searchModal.hasClass('is-open')) {
          closeModal();
        }
      });

      // Handle search input keyup events
      $(once('search-input', 'input[name="as_q"]', context)).keyup(function() {
        if ($(this).val() === '') {
          $('.search-popular', $searchModal).show();
          $('.search-results', $searchModal).hide();
        }
        else {
          $('.search-popular', $searchModal).hide();
          $('.search-results', $searchModal).show();
        }
      });

      // Custom validation message for minlength (hero and modal search)
      var minLengthMessage = 'Your search term must include more than one character';
      var attachMinLengthValidity = function(input) {
        var setValidity = function() {
          input.setCustomValidity(input.value.length < 2 ? minLengthMessage : '');
        };
        setValidity();
        input.addEventListener('input', setValidity);
      };

      $(once('hero-search-validity', '.hero-search-form #hero-search', context)).each(function() {
        attachMinLengthValidity(this);
      });

      $(once('modal-search-validity', '#modal-search-box', context)).each(function() {
        attachMinLengthValidity(this);
      });
    }
  };
})(Drupal, jQuery);
